import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AppUiModule } from '../../ui/app-ui.module';
import { SharedModule } from '../../shared/shared.module';
import { ReferencesRoutingModule } from './references-routing.module';
import { ReferencesComponent } from './references/references.component';

@NgModule({
  declarations: [ReferencesComponent],
  imports: [CommonModule, ReferencesRoutingModule, AppUiModule, SharedModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ReferencesModule {}
